export default "__VITE_ASSET__CSBL4n1i__"